module.exports = __webpack_public_path__ + "img/71.2d80e421.jpg";